import { toast } from "react-toastify";
import { EventConstants } from "../_constants";
import { EventService } from "../_services";

export const EventActions = {
  // getEventTypes,
  saveNewEvent,
  getChronicleEvents,
  copyEvent,
  updateEvent,
  deleteEvent,
  deleteMultiple,
  moveMultiple,
};

function getEventTypes() {
  return (dispatch) => {
    dispatch(request());

    EventService.loadEventTypes().then(
      (eventTypes) => {
        dispatch(success(eventTypes));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: EventConstants.FETCH_EVENT_TYPES_REQUEST,
    };
  }

  function success(result) {
    return {
      type: EventConstants.FETCH_EVENT_TYPES_SUCCESS,
      payload: result,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.FETCH_EVENT_TYPES_FAILURE,
      error,
    };
  }
}

function saveNewEvent(newEvent) {
  return (dispatch) => {
    dispatch(request(newEvent));

    return EventService.saveNewEvent(newEvent).then(
      (eventItem) => {
        toast.success(`Event "${eventItem.title}" created successfully!`);
        dispatch(success(eventItem));
        return eventItem;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - New Event: `, message);
        toast.error(`Unable to create new event "${newEvent.title}"`);
        dispatch(failure(message));
        throw error.toString();
      }
    );
  };

  function request(params) {
    return {
      type: EventConstants.SAVE_NEW_EVENT_REQUEST,
      params,
    };
  }

  function success(eventItem) {
    return {
      type: EventConstants.SAVE_NEW_EVENT_SUCCESS,
      payload: eventItem,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.SAVE_NEW_EVENT_FAILURE,
      error,
    };
  }
}

function getChronicleEvents(chronicleID) {
  return (dispatch) => {
    dispatch(request(chronicleID));

    return EventService.getChronicleEvents(chronicleID).then(
      (events) => {
        dispatch(success(events));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(params) {
    return {
      type: EventConstants.GET_CHRONICLE_EVENTS_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: EventConstants.GET_CHRONICLE_EVENTS_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.GET_CHRONICLE_EVENTS_FAILURE,
      error,
    };
  }
}

function copyEvent(id) {
  return (dispatch) => {
    dispatch(request);

    return EventService.createCopy(id).then(
      (result) => {
        toast.success(`Event "${result.title}" copied successfully!`);
        dispatch(success(result));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Copy Event`, message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: EventConstants.COPY_EVENT_REQUEST,
      params,
    };
  }

  function success(result) {
    return {
      type: EventConstants.COPY_EVENT_SUCCESS,
      payload: result,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.COPY_EVENT_FAILURE,
      error,
    };
  }
}

function updateEvent(eventID, eventData) {
  return (dispatch) => {
    dispatch(request(eventData));

    return EventService.updateEvent(eventID, eventData).then(
      (result) => {
        toast.success(`Event "${result.title}" updated!`);
        dispatch(success(result));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Update Event: `, message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: EventConstants.UPDATE_EVENT_REQUEST,
      params,
    };
  }

  function success(result) {
    return {
      type: EventConstants.UPDATE_EVENT_SUCCESS,
      payload: result,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.UPDATE_EVENT_FAILURE,
      error,
    };
  }
}

function deleteEvent(id) {
  return (dispatch) => {
    dispatch(request);

    return EventService.deleteEvent(id).then(
      () => {
        toast.success("Event successfully deleted!");
        dispatch(success(id));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Delete Event: `, message);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: EventConstants.DELETE_EVENT_REQUEST,
      params,
    };
  }

  function success(id) {
    return {
      type: EventConstants.DELETE_EVENT_SUCCESS,
      payload: id,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.DELETE_EVENT_FAILURE,
      error,
    };
  }
}

function deleteMultiple(eventIDs) {
  return (dispatch) => {
    dispatch(request(eventIDs));

    return EventService.deleteMultiple(eventIDs).then(
      (events) => {
        dispatch(success(events));
        toast.success(`Successfully deleted ${eventIDs.length} events!`);
      },
      (error) => {
        dispatch(failure(error.toString()));
        toast.error(`Unable to delete one or more events!`);
      }
    );
  };

  function request(params) {
    return {
      type: EventConstants.DELETE_MULTIPLE_EVENT_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: EventConstants.DELETE_MULTIPLE_EVENT_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.DELETE_MULTIPLE_EVENT_FAILURE,
      error,
    };
  }
}

function moveMultiple(timelineID, eventIDs) {
  return (dispatch) => {
    dispatch(request(timelineID, eventIDs));

    return EventService.moveMultiple(timelineID, eventIDs).then(
      (events) => {
        dispatch(success(events));
        toast.success(`Successfully moved ${eventIDs.length} events!`);
        return events;
      },
      (error) => {
        dispatch(failure(error.toString()));
        toast.error("Unable to update events!");
      }
    );
  };

  function request(timelineID, eventIDs) {
    return {
      type: EventConstants.MOVE_EVENT_REQUEST,
      params: { timeline: timelineID, events: eventIDs },
    };
  }

  function success(payload) {
    console.log("MOVE PAYLOAD", payload);
    return {
      type: EventConstants.MOVE_EVENT_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: EventConstants.MOVE_EVENT_FAILURE,
      error,
    };
  }
}
